import { render } from "./AthleteTable.vue?vue&type=template&id=d037635c&scoped=true"
import script from "./AthleteTable.vue?vue&type=script&lang=js"
export * from "./AthleteTable.vue?vue&type=script&lang=js"

import "./AthleteTable.vue?vue&type=style&index=0&id=d037635c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d037635c"]])

export default __exports__